import { useState } from 'react';
import { Settings, MessageSquare, Compass, Sparkles } from 'lucide-react';
import TripParametersPanel from './TripParametersPanel';
import AIAssistant from './AIAssistant';
import ExplorePanel from './ExplorePanel';
import InsightsPanel from './InsightsPanel';

export default function LeftPanel({
  itinerary,
  activities,
  accommodations,
  onActionExecuted,
  onAddAccommodation,
  onAddActivityFromChat,
  onParametersChanged,
  onInsightsUpdated,
  isRegenerating,
  onStartBlank,
}) {
  const [activeTab, setActiveTab] = useState('chat');

  const tabs = [
    { id: 'chat',     label: 'AI Chat',       icon: MessageSquare },
    { id: 'explore',  label: 'Explore',       icon: Compass },
    { id: 'insights', label: 'Insights',      icon: Sparkles },
    { id: 'settings', label: 'Trip Settings', icon: Settings },
  ];

  return (
    <div className="h-full flex flex-col bg-white rounded-lg shadow-lg overflow-hidden">
      {/* Tab bar */}
      <div className="flex gap-1 p-2 bg-charcoal-500 flex-shrink-0">
        {tabs.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            onClick={() => setActiveTab(id)}
            className={`flex-1 flex items-center justify-center gap-1.5 px-2 py-2 text-xs font-semibold rounded-lg transition-all ${
              activeTab === id
                ? 'bg-coral-400 text-white shadow-sm'
                : 'text-white/55 hover:text-white hover:bg-white/10'
            }`}
          >
            <Icon size={13} />
            <span className="truncate">{label}</span>
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="flex-1 overflow-hidden">
        {activeTab === 'settings' && (
          <TripParametersPanel
            itinerary={itinerary}
            onParametersChanged={onParametersChanged}
            isRegenerating={isRegenerating}
            onStartBlank={onStartBlank}
          />
        )}
        {/* Kept mounted (hidden, not unmounted) across tab switches so an
            in-flight AI reply and the conversation itself survive the user
            browsing Explore/Trip Settings and coming back. */}
        <div className="h-full" hidden={activeTab !== 'chat'}>
          <AIAssistant
            itinerary={itinerary}
            activities={activities}
            accommodations={accommodations}
            onActionExecuted={onActionExecuted}
            onAddAccommodation={onAddAccommodation}
            onAddActivity={onAddActivityFromChat}
          />
        </div>
        {activeTab === 'explore' && (
          <ExplorePanel
            activities={activities}
            itinerary={itinerary}
            onAddActivity={onAddActivityFromChat}
          />
        )}
        {activeTab === 'insights' && (
          <div className="h-full overflow-y-auto bg-platinum-50 p-3">
            <InsightsPanel itinerary={itinerary} onInsightsUpdated={onInsightsUpdated} />
          </div>
        )}
      </div>
    </div>
  );
}
